import { createApi } from '@reduxjs/toolkit/query/react';
import { Quote } from '../slice/initialState';
import { setQuotes } from '../slice/quoteSlice';
import { baseQueryWithProgress } from 'src/helpers/fetchQueryHelper';

export const quotesApi = createApi({
  reducerPath: 'quotesApi',
  baseQuery: baseQueryWithProgress,
  tagTypes: ['Quotes'],
  endpoints: (builder) => ({
    getQuotesByCompanyId: builder.query<Quote[], number>({
      query: (companyId) => `/quotes/company/${companyId}`,
      async onQueryStarted(_params, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setQuotes(data));
        } catch {
          console.error('error fetching quotes');
        }
      },
      providesTags: ['Quotes'],
    }),
    bindQuote: builder.query<{ success: boolean }, { quoteId: string }>({
      query: ({ quoteId }: { quoteId: string }) => `/coverwhale/quote/bind/${quoteId}`,
    }),
    generateSignedUrl: builder.mutation<
      {
        signedUrl: string;
      },
      {
        fileName: string;
      }
    >({
      query: (fileName: { fileName: string }) => ({
        url: `/producer/aws/generate_signed_url`,
        method: 'POST',
        body: fileName,
      }),
    }),
  }),
});

export const {
  useGetQuotesByCompanyIdQuery,
  useLazyGetQuotesByCompanyIdQuery,
  useBindQuoteQuery,
  useLazyBindQuoteQuery,
  useGenerateSignedUrlMutation,
} = quotesApi;
